export const isLastPage = (lastPage, take) => {
    if (!lastPage?.nextSkip) {
        return false
    }
    return lastPage.nextSkip
}